var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { AppearanceSettings } from 'packages/job_lists/AppearanceSettings';
import { SharingSettings } from 'packages/job_lists/SharingSettings';
import { NavigationLink } from 'packages/job_lists/NavigationLink';
import { AccessToken } from 'packages/utilities/AccessToken';
import env from 'config/env';
var JobList = /** @class */ (function (_super) {
    __extends(JobList, _super);
    function JobList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.companyId = null;
        _this.botId = null;
        _this.name = null;
        _this.title = null;
        _this.text = null;
        _this.subtitle = null;
        _this.button = null;
        _this.useTitle = false;
        _this.domain = null;
        _this.subdomain = null;
        _this.stringIdentifier = null;
        _this.published = false;
        _this.locale = 'fi-FI';
        _this.activeJobCount = null;
        _this.appearance = null;
        _this.sharingSettings = null;
        _this.navigation = [];
        _this.accessToken = null;
        return _this;
    }
    Object.defineProperty(JobList.prototype, "subdomainUrl", {
        get: function () {
            return "https://" + this.subdomain + "." + env.ROOT_DOMAIN;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobList.prototype, "url", {
        get: function () {
            return this.domain ? "https://" + this.domain : this.subdomainUrl;
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    JobList.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (this.navigation && this.navigation.length) {
            var position_1 = 0;
            this.navigation = this.navigation
                .sort(function (a, b) {
                if (!a.position || b.position < a.position) {
                    return 1;
                }
                if (!b.position || a.position < b.position) {
                    return -1;
                }
                return 0;
            })
                .map(function (navigationLink) {
                position_1++;
                navigationLink.position = position_1;
                return navigationLink;
            });
        }
    };
    JobList.prototype.toSaveRequest = function () {
        var requestJson = this.toJson();
        if (requestJson.appearance.favicon) {
            requestJson.favicon_id = requestJson.appearance.favicon.id;
        }
        delete requestJson.appearance.favicon;
        return requestJson;
    };
    var _a, _b, _c;
    __decorate([
        Type(AppearanceSettings),
        __metadata("design:type", typeof (_a = typeof AppearanceSettings !== "undefined" && AppearanceSettings) === "function" ? _a : Object)
    ], JobList.prototype, "appearance", void 0);
    __decorate([
        Type(SharingSettings),
        __metadata("design:type", typeof (_b = typeof SharingSettings !== "undefined" && SharingSettings) === "function" ? _b : Object)
    ], JobList.prototype, "sharingSettings", void 0);
    __decorate([
        Type(NavigationLink),
        __metadata("design:type", Array)
    ], JobList.prototype, "navigation", void 0);
    __decorate([
        Type(AccessToken),
        __metadata("design:type", typeof (_c = typeof AccessToken !== "undefined" && AccessToken) === "function" ? _c : Object)
    ], JobList.prototype, "accessToken", void 0);
    return JobList;
}(Entity));
export { JobList };
